@if (dunningTypeLevelTriggerLogicFieldData) {
    <mvs-widget [widgetData]="dunningTypeLevelTriggerLogicFieldData"></mvs-widget>
}
